/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RejectOrderDto
 */
export interface RejectOrderDto {
    /**
     * 
     * @type {string}
     * @memberof RejectOrderDto
     */
    rejectedNote: string;
}

/**
 * Check if a given object implements the RejectOrderDto interface.
 */
export function instanceOfRejectOrderDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "rejectedNote" in value;

    return isInstance;
}

export function RejectOrderDtoFromJSON(json: any): RejectOrderDto {
    return RejectOrderDtoFromJSONTyped(json, false);
}

export function RejectOrderDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RejectOrderDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'rejectedNote': json['rejectedNote'],
    };
}

export function RejectOrderDtoToJSON(value?: RejectOrderDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'rejectedNote': value.rejectedNote,
    };
}

